
import { computed, defineComponent, PropType } from 'vue';
import { CallToActionTileModel } from '@/types/B2BcontentServerContract';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import IndicatorsForNativeHorizontalScroll
    from '@/shared/content/blocks/native-scroll/IndicatorsForNativeHorizontalScroll.vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';

export default defineComponent({
    name: 'CallToAction3In1Layout',
    components: {
        IndicatorsForNativeHorizontalScroll,
        MediaHandler,
        CMSLinkHandler,
    },
    props: {
        content: {
            type: Object as PropType<CallToActionTileModel>,
            required: true,
        },
    },

    setup(props) {
        const showCarousel = computed(() => {
            const tileHasMoreThanOneTileContentBlock = props.content.tiles.length > 1;
            const useCarouselIsEnabled = props.content.useCarouselOnMobile;
            const isMobileOrTablet = breakpointsState.activeBreakpoint === 'xs' || breakpointsState.activeBreakpoint === 'sm';
            return tileHasMoreThanOneTileContentBlock && isMobileOrTablet && useCarouselIsEnabled;
        });

        const aspectRatioWithoutCarousel = computed(() => {
            const defaultRatio = {
                xs: props.content.alternativeImageLayout ? 7 / 8 : 375 / 219,
                default: props.content.alternativeImageLayout ? 2 : 5 / 2,
            };
            switch (props.content.tiles.length) {
            case 1:
                return defaultRatio;
            case 2:
                return {
                    xs: defaultRatio.xs,
                    default: props.content.alternativeImageLayout ? 10 / 9 : 5 / 3,
                };
            case 3:
                return {
                    xs: defaultRatio.xs,
                    default: props.content.alternativeImageLayout ? 4 / 5 : 62 / 40,
                };
            default:
                return defaultRatio;
            }
        });

        const aspectRatioWithCarousel = computed(() => {
            return { xs: 2 / 3, default: 7 / 8 };
        });

        return {
            aspectRatioWithCarousel,
            aspectRatioWithoutCarousel,
            showCarousel,
        };
    },
});
